
document.addEventListener("DOMContentLoaded", function () {

	//準備
	const mainList = document.getElementById('main-carousel');
	const thumbList = document.getElementById('thumbnail-carousel');

	//スライド番号
	let num = 0;
	// メインスライダー設定
	let mainOption = {
		type: "loop",
		rewind: true,
		pagination: false,
		arrows: true
	}
	let main = new Splide(mainList, mainOption);

	// サムネイル設定
	let thumbOption = {
		type: "slide",
		perPage: 6,
		pagination: false,
		isNavigation: true,
		arrows: false,
		breakpoints: {
			400: {
				//fixedWidth: 80,
			},
		}
	}
	const thumbnails = new Splide(thumbList, thumbOption);

	//splide起動
	main.sync(thumbnails);
	main.mount();
	thumbnails.mount();

});


//variant
const productWrap = document.querySelector('.product__info-wrapper');
const spBuyBtn = document.getElementById('spBuyBtn');
if (spBuyBtn != null) {
	spBuyBtn.addEventListener('click', function () {
		productWrap.classList.add('popup');
		document.documentElement.classList.add('is-popup');
		document.body.classList.add('is-popup');
	});
}

const cmorgClose = document.getElementById('cmorgClose');
if (cmorgClose != null) {
	cmorgClose.addEventListener('click', function () {
		productWrap.classList.remove('popup');
		document.documentElement.classList.remove('is-popup');
		document.body.classList.remove('is-popup');
	});
}

//Styling view more
const moreBtn = document.getElementsByClassName('moreBtn');
const closeBtn = document.getElementsByClassName('closeBtn');
for (let i = 0; i < moreBtn.length; i++) {
	moreBtn[i].addEventListener('click', function () {
		let ul = moreBtn[i].previousElementSibling;
		let close = moreBtn[i].nextElementSibling;
		ul.classList.add('all');
		moreBtn[i].style.display = "none";
		close.style.display = "block";
	});
	closeBtn[i].addEventListener('click', function () {
		let ul = moreBtn[i].previousElementSibling;
		ul.classList.remove('all');
		moreBtn[i].style.display = "block";
		closeBtn[i].style.display = "none";
	});
}
